import Brett from "./Brett";
import {v3} from "oc-threejs/short3";

export default class SockelBrett extends Brett {
    // DO NOT CHANGE: Hier wird der Classname des Brettes verwendet - für Einheitlichkeit in der JSON
    className = "Brett";

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    constructor(schrank, mainAxis) {
        super(schrank, 'Sockel', mainAxis || 'xy');
    }

    compile() {
        // const outer = this.schrank.corpusBox;
        // const inner = this.schrank.elementsBox;
        // const xBox = this.schrank.options.getBool('aussenwand_durchgehend_unten') && this.schrank.sockelOption != "mitBlende" ? inner : outer;

        // const sockelFront = inner.max.z - this.schrank.options.getFloat( 'sockel_ruecksprung_vorn');
        // const boxMinY = outer.min.y - (this.schrank.sockelOption == "mitBlende" ? this.schrank.sockelHoehe : 0.0);
        // this.box = new THREE.Box3(
        //     v3(xBox.min.x, boxMinY, sockelFront - this.schrank.options.getFloat('brett_staerke')),
        //     v3(xBox.max.x, boxMinY + this.schrank.sockelHoehe, sockelFront)
        // );
        // this.boxToVertices();
        // if(this.object3d && _.isEmpty(this.object3d?.geometry?.attributes)) {
        //     this.object3d.updateGeometry();
        // }
        
        super.compile();
    }

    getMaterialProduct() {
        if (!Commons.isEmpty(APP.arrangement.materials.sockel)) {
            return APP.findProduct(this.materialArtikelnummer);
        } else {
            return null;
        }
    }

    get materialArtikelnummer() {
        return APP.arrangement.materials.sockel;
    }
}